import React, {createContext, useReducer} from 'react'
import {StageFilterReducer} from "../reducers/StageFilterReducer";
import {CART_VIEW, ROUTE_VIEW} from "../../util/Constants";
import {saveFilterState} from "../../util/Util";
import {STAGE_FILTER_STATE_KEY} from "../../util/LocalStorageKeys";

export const StageFilterContext = createContext();

const StageFilterContextProvider = (props) => {
    let initialState = {
        xptNodes: null,
        departure: [],
        driverType: [],
        cluster: [],
        viewType: CART_VIEW,
        stageTabViewType: ROUTE_VIEW,
        status: [],
        stageLocationType: [],
        data: {
            xptNodes: [],
            departure: [],
            driverType: [],
            cluster: []
        }
    }
    const urlState = props.context ? JSON.parse(props.context.replace('%2f', '/')) : null;
    if (urlState) {
        initialState = {...initialState, ...urlState};
        saveFilterState(STAGE_FILTER_STATE_KEY, initialState);
    }

    const [viewModelF, dispatchF] = useReducer(StageFilterReducer, initialState);
    return (
        <StageFilterContext.Provider value={{viewModelF, dispatchF}}>
            {props.children}
        </StageFilterContext.Provider>
    )
}

export default StageFilterContextProvider


// WEBPACK FOOTER //
// ./src/components/stageStatus/context/StageFilterContext.js